import React from 'react'
import styled from "@emotion/styled"

import Preview from '../Templates/Preview'
import Categories from '../Templates/Categories'
import PartsList from '../Templates/PartsList'
import ThemeSelector from '../Templates/ThemeSelector'
import Modal from '../organism/Modal'

const Avatar = () => {
  return (
    <SMain>
      <Preview />
      <Categories />
      <PartsList />
      <ThemeSelector />
      <Modal />
    </SMain>
  )
}

const SMain = styled.div`
  width: 400px;
`;

export default Avatar
